"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LevelLists_1 = require("./LevelLists");
/**
 * @internal
 * create an empty WordConverterArguments
 */
function createWordConverterArguments(nodes) {
    return {
        nodes: nodes,
        currentIndex: 0,
        lists: {},
        listItems: [],
        currentListIdsByLevels: [LevelLists_1.createLevelLists()],
        lastProcessedItem: null,
    };
}
exports.createWordConverterArguments = createWordConverterArguments;
//# sourceMappingURL=WordConverterArguments.js.map